import ProductListIsland from './components/product-list-island/ProductListIsland.vue';

export default function registerAdminVueComponents(app) {
    app.component('product-list-island', ProductListIsland);
}
